import { render, staticRenderFns } from "./EUServicesReport.vue?vue&type=template&id=15be5bed&scoped=true&"
import script from "./EUServicesReport.vue?vue&type=script&lang=js&"
export * from "./EUServicesReport.vue?vue&type=script&lang=js&"
import style0 from "./EUServicesReport.vue?vue&type=style&index=0&id=15be5bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be5bed",
  null
  
)

export default component.exports